import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import SupportTicker from './SupportTicker';

const Layout: React.FC = () => {
  return (
    <div className="App min-h-screen flex flex-col bg-white dark:bg-[#0a0e27]">
      <SupportTicker />
      <Header />
      <main className="App-main flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
